<template>
  <div>
    <Table
      :no-data-text="$t('common.noData')"
      :columns="columns"
      :data="tableDate"
      style="width: 100.1%"
    >
      <template slot-scope="{ row, index }" slot="delete">
        <span @click="doDelete(index)">
          <Button
            type="error"
            size="small"
            v-hasPermission="['monitor:elasticResourceAli:delete']"
            @click="tableDelmodal = true"
            >{{ $t("alarms.common.delete") }}</Button
          >
        </span>
        <Button
          type="info"
          size="small"
          v-hasPermission="[
            'monitor:elasticResourceAli:queryEipByAllocationId'
          ]"
          @click="rowClick(row)"
          >{{ $t("alarms.common.details") }}</Button
        >
      </template>
    </Table>
    <!-- 删除模式框 -->
    <Modal v-model="tableDelmodal" width="360" :mask-closable="false">
      <p slot="header" style="color: #f60; text-align: center">
        <Icon type="ios-information-circle"></Icon>
        <span>{{ $t("alarms.common.deleteConfirmation") }}</span>
      </p>
      <div style="text-align: center">
        <p>
          {{ $t("alarms.common.sureDelete") }} {{ elasticResourceName }}
          {{ $t("alarms.common.allWarningRules") }} ？
        </p>
      </div>
      <div slot="footer">
        <Button
          type="error"
          size="large"
          long
          :loading="modal_loading"
          @click="removeElasticResource()"
          :disabled="isDisable"
          >{{ $t("alarms.common.delete") }}</Button
        >
      </div>
    </Modal>
    <!-- :page-size-opts="[2,4,6,8]" -->
    <Page
      :current="current"
      :total="dataTotal"
      show-sizer
      :page-size="pageSize"
      @on-change="changePage"
      @on-page-size-change="changeSize"
      :transfer="true"
    ></Page>
  </div>
</template>
<script>
var tableElasticResourceVue = {};
export default {
  name: "TableElasticResourceAli",
  data() {
    return {
      current: 1,
      dataTotal: 0,
      pageSize: 10,
      tableDelmodal: false,
      isDisable: false,
      modal_loading: false,
      val: "",
      region: "",
      elasticResourceName: "",
      columns: [
        {
          title: this.$t("alarms.instance.accountType"),
          key: "accountTypeName"
        },
        {
          title: this.$t("alarms.instance.accountName"),
          key: "accountName"
        },
        {
          title: this.$t("alarms.instance.publicIp"),
          key: "publicIp"
        },
        {
          title: this.$t("alarms.instance.allocationId"),
          key: "allocationId"
        },
        {
          title: this.$t("alarms.instance.privateIp"),
          key: "privateIp"
        },
        {
          title: this.$t("alarms.instance.instanceId"),
          key: "instanceId"
        },
        {
          title: this.$t("common.operation"),
          slot: "delete"
        }
      ],
      tableDate: []
    };
  },
  beforeCreate: function() {
    tableElasticResourceVue = this;
  },
  created() {
    eventBus.$on("companyId", function(val) {
      tableElasticResourceVue.companyId = val;
    });
    eventBus.$on("accountType", function(val) {
      tableElasticResourceVue.accountType = val;
    });
    eventBus.$on("accountName", function(val) {
      tableElasticResourceVue.accountName = val;
    });
    eventBus.$on("publicIp", function(val) {
      tableElasticResourceVue.publicIp = val;
    });
  },
  mounted: function() {},
  methods: {
    showAll: function() {
      tableElasticResourceVue.getElasticResourceData();
    },
    // 分页显示数据
    /****************************************************/
    getElasticResourceData: function() {
      var jjson = {};
      if (null != tableElasticResourceVue.companyId) {
        jjson.companyId = tableElasticResourceVue.companyId;
      }
      if (
        null != tableElasticResourceVue.accountType &&
        "" != tableElasticResourceVue.accountType
      ) {
        jjson.accountType = tableElasticResourceVue.accountType;
      }
      if (null != tableElasticResourceVue.accountName) {
        jjson.accountName = tableElasticResourceVue.accountName;
      }
      if (null != tableElasticResourceVue.publicIp) {
        jjson.publicIp = tableElasticResourceVue.publicIp;
      }
      jjson.pageNum = this.current;
      jjson.pageSize = this.pageSize;
      //列表分页
      this.$api.eip
        .pageEip(jjson)
        .then(res => {
          this.tableDate = res.data.records;
          // 当前页
          this.current = res.data.current;
          // 总条数
          this.dataTotal = res.data.total;
        })
        .catch(err => {});
    },
    changePage: function(current) {
      this.current = current;
      tableElasticResourceVue.getElasticResourceData();
    },
    changeSize: function(pageSize) {
      this.pageSize = pageSize;
      tableElasticResourceVue.getElasticResourceData();
    },
    // 删除
    /****************************************************/
    doDelete: function(index) {
      this.lineIndex = index;
      this.elasticResourceName = this.tableDate[index].accountName;
    },
    removeElasticResource: function() {
      this.isDisable = true; //开始可以点击
      var lineIndex = this.lineIndex;
      //删除
      this.$api.eip.deleteEip("id", this.tableDate[lineIndex].id).then(res => {
        this.modal_loading = true;
        setTimeout(() => {
          // 最后一页全部删除 显示前一页(当前页为最后一页，如何判断？当前页-1*每页数=总数)
          //21条  3页  2*10+1时删除
          if (
            lineIndex == 0 &&
            (this.current - 1) * this.pageSize + 1 == this.dataTotal
          ) {
            this.current = this.current - 1;
          }
          this.dataTotal = this.dataTotal - 1;
          tableElasticResourceVue.getElasticResourceData();
          this.isDisable = false;
          this.modal_loading = false;
          this.tableDelmodal = false;
          this.$Message.success("删除成功");
        }, 1000);
      });
    },
    // 单击行
    /****************************************************/
    rowClick: function(row) {
      this.$router.push({
        path: "/monitor/elasticResourceDetailAli/",
        query: {
          id: row.id,
          accountId: row.accountId,
          name: row.clusterIdentifier,
          region: row.region,
          accountTypeName: row.accountTypeName,
          accountName: row.accountName,
          publicIp: row.publicIp,
          allocationId: row.allocationId,
          monitorModule: 37
        }
      });
    }
  }
};
</script>
<style scoped>
.ivu-page {
  margin-top: 10px !important;
  margin-bottom: 30px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/monitor/eip/TableElasticResourceAli.vue